export const normalizeAmountToBackend = amount =>
  parseInt(amount * 100000000, 10)
